import axios from "axios";
import { ZDASH_URL } from "@/constants";

export default class SignupService {
  save(data) {
    return axios.post(`${ZDASH_URL}/api/signup/`, data).then((response) => {
      return response.data;
    });
  }

  update(id, data) {
    return axios
      .patch(`${ZDASH_URL}/api/signup/${id}/`, data)
      .then((response) => {
        return response.data;
      });
  }

  prices() {
    return axios.get(`${ZDASH_URL}/api/signup/prices/`).then((response) => {
      return response.data;
    });
  }

  get(id) {
    return axios.get(`${ZDASH_URL}/api/signup/${id}/`).then((response) => {
      return response.data;
    });
  }

  cart(id) {
    return axios.get(`${ZDASH_URL}/api/signup/${id}/cart/`).then((response) => {
      return response.data;
    });
  }

  finish(id) {
    return axios
      .post(`${ZDASH_URL}/api/signup/${id}/finish/`)
      .then((response) => {
        return response.data;
      });
  }

  toWaitList(data) {
    return axios
      .post(`${ZDASH_URL}/api/signup-wait-list/`, data)
      .then((response) => {
        return response.data;
      });
  }

  promocode(id, promocode) {
    return axios
      .post(`${ZDASH_URL}/api/signup/${id}/promocode/`, { promocode })
      .then((response) => {
        return response.data;
      });
  }

  getPlaid(id) {
    return axios
      .get(`${ZDASH_URL}/api/signup/${id}/plaid/`)
      .then((response) => {
        return response.data;
      });
  }

  payPlaid(id, data) {
    return axios
      .post(`${ZDASH_URL}/api/signup/${id}/plaid/`, data)
      .then((response) => {
        return response.data;
      });
  }
}

export class BusinessService {
  constructor(uuid) {
    this.uuid = uuid;
  }

  getPlaid() {
    return axios
      .get(`${ZDASH_URL}/api/business/${this.uuid}/payment-info/plaid-ach/`)
      .then((response) => {
        return response.data;
      });
  }
  savePlaid(data) {
    return axios
      .post(
        `${ZDASH_URL}/api/business/${this.uuid}/payment-info/plaid-ach/`,
        data
      )
      .then((response) => {
        return response.data;
      });
  }
  getBusiness() {
    return axios
      .get(`${ZDASH_URL}/restaurants/`, { params: { uuid: this.uuid } })
      .then((response) => {
        const data = JSON.parse(response.data);
        const obj = data[0].fields;
        obj.id = data[0].pk;
        return obj;
      });
  }
}

export const signupService = new SignupService();
